import { environment } from "environments/environment";

export const locale = {
  lang: "fr",
  data: {
    MENU: {
      EXAMPLE: "Example",
      TABLE: "Tableau",
      FORM: "Depuis",
    },
    GENERAL: {
      FILTERS: "Filtres",
      RESET_FILTERS: "Réinitialiser les filtres",
      LOADING: "Chargement...",
      ADD: "Ajouter",
      EDIT: "Modifier",
      DELETE: "Supprimer",
      ERROR: "Error",
      RECOVER_DATA_ERR: "Les données n'ont pas pu être récupérées",
      CODE: "Code",
      DAY: "Jour",
      DESCRIPTION: "Description",
      ACTIONS: "Actions",
      OK: "OK",
      CANCEL: "Annuler",
      //Generic messages
      CORRECT_UPDATE: "Mise à jour réussie",
      BAD_UPDATE: "Mise à jour a échoué",
      CORRECT_SAVE: "Créé avec succès",
      BAD_SAVE: "Non créé",
      LOGIN: "Connexion",
      USER_CODE: "Code d'utilisateur",
      LANGUAGE: "Langue",
      USER: "Utilisatrice",
      PLANIFICATION: "Planification",
      MACHINES: "Machines",
      ERROR_RECOVERING_DATA: "Erreur de récupération des données",
      MACHINE_NOT_SELECTED: "Machine non sélectionnée",
      OFFLINE: "Hors ligne",
      SELECT: "Sélectionner",
      SELECT_MACHINE: "Sélectionner la machine",
      SELECT_OF: "Sélectionner une OF",
      ONLY_ASSIGNED_TO_THIS_MACHINE: "Uniquement assignée à cette machine",
      SHOW_UNASSIGNED: "Inclus non assisté",
      SEARCH_OF: "Recherche OF",
      PREPARE_MACHINE: "Préparer la machine",
      CONNECTION_LOST: "Connexion perdue",
      CONNECTION_LOST_ERROR:
        "Connexion perdue, l'application ne peut pas fonctionner correctement",
      START: "Commencer",
      PROD: "production",
      IDLE: "Arrêté",
      EMERG: "Urgence",
      PREP: "Préparation",
      OF_NUMBER: "Numéro OF",
      REFERENCE: "Référence",
      PHASE: "phase",
      PREPARED_BY: "Préparé par",
      SELECT_NEW_OF: "Sélectionner nouveau OF",
      START_PRODUCTION: "Commencer la production",
      START_DATE: "Date de début",
      END_DATE: "Date de fin",
      MACHINE: "Machine",
      OF: "OF",
      QUANTITY: "Quantité",
      OBSERVATIONS: "Observations",
      PRODUCTION_SHEET: environment.eurogerm
        ? "Fiche de fabrication"
        : "Observations",
      NO_PRODUCTION_SHEET: environment.eurogerm
        ? "Il n'y a pas du fiche de fabrication"
        : "Il n'y a pas d'observations",
      CLOSE: "Fermer",
      PREPARATION_ENDED: "Préparation finie",
      PRODUCTION_ENDED: "Production finie",
      NO_PLANIFICATIONS: "Actuellement, vous n'avez aucune planification",
      SELECT_REFERENCE: "Sélectionner la référence",
      MULTIPLE_MACHINES:
        "Le sélectionné est configuré pour être produit sur une autre machine.Sur quelle machine voulez-vous produire le de?",
      COMPONENTS: "Composantes",
      TIME_PREPARATION: "Temps de préparation",
      TIME_PRODUCTION: "Temps de production",
      TIME_LEFT: "Temps restant",
      PRODUCED_BY: "Produit par",
      PRODUCTION: "Production",
      PIECES_OK: "Pièces OK",
      PIECES_NOK: "Pièces NOK",
      ASSIGN_TO_PRODUCTION: "Assigner à la production",
      ASSIGN_UNASSIGNED: "Des pièces ont été produites hors de la production",
      ASSIGN_UNASSIGNED_MESSAGE:
        "{{count}} des pièces ont été produites depuis la dernière production.Le premier a été produit sur {{startDate}} et le dernier a été produit sur {{endDate}}.",
      DISCARD: "Éliminer",
      ASSIGN: "Attribuer",
      PROTOTYPE: "Prototype",
      PRODUCTION_TYPE: "Type de production",
      JUSTIFY_NOK: "Justifier NOK",
      NOK_JUSTIFIED_PIECES: "NOK pièces justifiées",
      TOTAL_PIECES_NOK: "Nombre total de pièces NOK",
      STOP_PRODUCTION: "Finaliser la production",
      ERROR_STARTING: "Erreur au démarrage de la production",
      STOP_PREPARATION: "Finaliser la préparation",
      CADENCE: "Cadence",
      CONTAINER_CODE: environment.eurogerm
        ? "Code de cycle"
        : "Code de conteneur",
      CONTAINER: environment.eurogerm ? "Cycle" : "Conteneur",
      START_CONTAINER: "Commencer",
      STOP_CONTAINER: environment.eurogerm
        ? "Terminer le cycle"
        : "Terminer le conteneur",
      MUST_CLOSE_CONTAINER: environment.eurogerm
        ? "Vous devez fermer tous les cycles ouverts avant de finaliser la production"
        : "Vous devez fermer tous les conteneurs ouverts avant de finaliser la production",
      START_CONTAINER_ERROR: environment.eurogerm
        ? "Impossible de démarrer le cycle"
        : "Impossible de démarrer le conteneur",
      STOP_CONTAINER_ERROR: environment.eurogerm
        ? "Impossible de mettre fin au cycle"
        : "Impossible de mettre fin au conteneur",
      OF_EMPTY: "Actuellement, il n'y a pas pour cette machine",
      NO_OBSERVATIONS: "Il n'y a pas d'observations",
      SELF_SIGNED_CERT: "Certificat auto-signé",
      SELF_SIGNED_CERT_MESSAGE:
        "Vous devez accepter le certificat pour pouvoir communiquer avec la machine",
      DOCUMENTATION: "Documentation",
      NAME: "Nom",
      PRINT_LAST_PRODUCTION: "Imprimer étiquette",
      CONTROLS: "Contrôles",
      AS: "Démarrage de série",
      FS: "Fin de série",
      ITU: "Début du poste",
      DA: "Après une panne",
      PENDING_POINTS: "Questionnaires de qualité en attente",
      PENDING_POINT: "Questionnaire de qualité",
      OF_DE: "de",
      BACK: "Retourner",
      NEXT: "Suivante",
      FINISH: "Finaliser",
      SUBMIT: "Soumettre",
      PIECES: "Pieces",
      ERROR_STOPPING: "La production ne pouvait pas être terminée",
      EMERGENCY_STOP: "Arrêt d'urgence",
      PROPOSE_STOP: "Arrêt proposé",
      STOP: "Arrêt",
      SHUTDOWN: "Fermer",
      OTHERS: "Autres",
      MACHINE_ON: "Machine on",
      PREPARATION: "Préparation",
      JUSTIFY_STOPS: "Justifier les arrêts",
      JUSTIFY_STOP: "Justifier Stop",
      MANUAL: "Manual",
      STOP_TIME: "Temps d'arrêt",
      JUSTIFY: "Justifier",
      READ: "Lire",
      QR_CODE: "Code QR étiqueter",
      COMPONENT_NAME: "Nom du composant",
      EXPIRATION: "Expiration",
      ACCEPT_EXPIRED_COMPONENT: "Acceptez le composant expiré",
      RESPONSIBLE_VALIDATION: "Validation de responsable",
      RESPONSIBLE_USER_CODE: "Code utilisateur responsable",
      ACCEPT: "Accepter",
      NO_LAST_PRODUCTION: "Impossible de trouver la dernière production",
      NO_LAST_CONTAINER: environment.eurogerm
        ? "Impossible de trouver le dernier cycle"
        : "Impossible de trouver le dernier conteneur",
      DATE: "Date",
      EXTRA_INFORMATION: "Informations supplémentaires",
      CONFIGURATION: "Configuration",
      CONNECTING: "De liaison",
      OPEN: "Ouvrir",
      CLOSING: "Fermeture",
      CLOSED: "Fermée",
      CURRENT_VERSION: "Version actuelle",
      CHANGE: "Changer",
      CONFIGURATION_PASSWORD: "Mot de passe de configuration",
      INCORRECT_PASSWORD: "Mot de passe incorrect",
      TRY_AGAIN: "Essayer à nouveau",
      TEAMS: "Équipes",
      TEAM: "Équip",
      SELECT_TEAM: "Choisis une équipe",
      WORKERS_NOT_FOUND: "Aucun opérateur n'a été trouvé",
      COMPONENT_INDEX: environment.eurogerm
        ? "Cycle {0} de {1}"
        : "Conteneur {0} de {1}",
      DIVIDE: "Diviser",
      ERROR_UPDATING_MEMBERS: "Impossible de mettre à jour les membres",
      MODIFY_TEAM: "Modifier l'équipe",
      NO_MACHINES: "Aucune machine disponible",
      OEE: "TRS",
      FAULT: "Panne",
      CORRECTIVE: "Correctif",
      PREVENTIVE: "Préventif",
      SELECT_DEVICE_MODE: "Mode",
      MAINTENANCE: "Maintenance",
      AUTOMATIC: "Automatique",
      DEFAULT_MACHINES: "Machines par défaut",
      MAXIMUM_DIFFERENCE_BETWEEN_REPORTED_AND_COUNTED_PIECES:
        "Différence maximale entre pièces déclarées et comptées",
      MAXIMUM_DIFFERENCE_EXCEEDED: "Différence maximale dépassée",
      SHOW_INPUT_KG_UNIT_LOT: "Afficher l'entrée pour kg/unité et lot",
      KG_UNIT: "kg/unité",
      LOT: "Lot",
      BOX_CODE: "Code de la boîte",
      SHOW_BOX_CODE: "Afficher le code de la boîte",
      SOCKET_LOCAL_DISCONNECTED: "Socket Local Débranché",
      SOCKET_LOCAL_DISCONNECTED_ERROR:
        "La connexion socket locale est perdue, l'application ne peut pas fonctionner correctement",
      TESTS: "Operations tests",
      RESPONSIBLE_PRODUCCION: "Responsable Production",
      END: "Fin",
      NOK: "NOK",
      METERS: "Mètres",
      LITERS: "Litres",
      BOXES: "Des boites",
      KG: "Kg",
      SACKS: "Sacs",
      NOK_JUSTIFIED_UNIT: "NOK {{unit}} justifiées",
      TOTAL_UNIT_NOK: "Nombre total de {{unit}} NOK",
      SHOW_STOP_SCREEN: "Afficher l'écran du total des arrêts",
      PER_CYCLE: "par cycle",
      TOTAL_PLANNED_STOPS: "Total des arrêts prévus",
      INCORRECT_USER_CODE: "Code utilisateur incorrect",
      PRODUCTIVITY: "Productivité",
      SHOW_DIVIDE_CONTAINER: environment.eurogerm
        ? "Afficher le cycle divisé"
        : "Afficher le conteneur divisé",
      CLOSE_CONTAINER: environment.eurogerm
        ? "Fermer le cycle"
        : "Fermer le conteneur",
      FROM_PREVIOUS_PRODUCTION: "De les productions précédentes",
      WAITING_BAR_CODE_LECTURE: "En attente de lecture du code-barres",
      ENTER_CODE_MANUALY: "Entrez le code manuellement",
      SELECT_COMPONENT: "Sélectionner un composant",
      LOTS_ENTERED: "Lots entrés",
      QUANTITY_CANT_BE_ZERO:
        "Le quantité ne peut pas être égal à 0 ou inférieur à 0",
      QUANTITY_CANT_BE_LESS_ZERO: "La quantité ne peut pas être inférieure à 0",
      QUANTITY_CANT_BE_EDITED: "Impossible de modifier la quantité",
      NO_COMPONENTS: "Il n'y a aucun composant",
      ERROR_SAVING_DATA: "Erreur lors de l'enregistrement des données",
      SURE_YOU_WANT_TO_LEAVE: "Tu veux vraiment sortir",
      CHANGES_WILL_NOT_BE_SAVED:
        "Si vous avez apporté des modifications, elles ne seront pas enregistrées",
      ALL_IN_ONE_CONTAINER: environment.eurogerm
        ? "Le tout dans un seul cycle"
        : "Le tout dans un seul conteneur",
      NO_CONTAINERS: environment.eurogerm
        ? "Aucune cycles disponible"
        : "Aucune conteneur disponible",
      SELECT_NEW_CONTAINER: environment.eurogerm
        ? "Sélectionnez un nouveau cycle"
        : "Sélectionnez un nouveau conteneur",
      ASK_FOR_MEASURES: "Demander les mesures",
      HIDE_CADENCE: "Masquer la cadence",
      SHOW_CADENCE: "Montrer la cadence",
      WARNING: "Attention",
      MACHINE_NOT_READY: "La machine n'est pas préparée",
      DB_PRINT_TEMPLATE_BUTTON: "Modèle DB PRINT bouton",
      PRODUCTION_START_COMMANDS:
        "Commandes à envoyer lorsque la production est démarrée",
      MASTER_SLAVE_MODE: "Chemin Master/Slave",
      NEXT_CONTAINER_NOT_SCANNED_COMPONENTS: environment.eurogerm
        ? "Les composants du prochain cycle n'ont pas été vérifiés, vous devez les vérifier avant de continuer"
        : "Les composants du prochain conteneur n'ont pas été vérifiés, vous devez les vérifier avant de continuer",
      ADD_PREPARATION_COMPONENT: "Ajouter le composant de préparation",
      ADD_COMPONENTS: "Ajouter des composants",
      COMPONENT_CODE: "Code composant",
      COMPONENT: "Component",
      USE_PREVIOUS_LOTS: "Utiliser les lots précédents",
      PREVIOUS_LOTS: "Lots précédents",
      ADD_PRODUCTION_COMPONENT: "Ajouter le composant",
      TEXT_PRODUCTION_BUTTON: "Texte du bouton de production",
      TIME_INTERVAL_BUTTON: "Intervalle de temps pour le bouton de production",
      HIDE_PRODUCTION_DETAIL: "Masquer les détails de la production",
      STATION_NAME_REQUIRED: "Un nom de station est nécessaire",
      STATION_NAME_REQUIRED_MSG:
        "Un nom de station est nécessaire avant de créer / modifier une configuration",
      STATION_NAME: "Nom de station",
      EXPORT_CONFIGURATION: "Importer",
      EDIT_CONFIGURATION: "Modifier",
      IMPORT_CONFIGURATION: "Exporter",
      CONFIGURATIONS: "Configurations",
      NO_CONFIGURATIONS: "Sans configurations",
      IMPORT_CONFIGURATION_QUESTION: "Importer la configuration?",
      IMPORT_CONFIGURATION_QUESTION_MSG:
        "Souhaitez-vous importer et écraser la configuration actuelle?",
      SAVE: "Garder",
      SAVE_ALL_LOCAL: "Gardez tout localement",
      GENERAL_TIME_INTERVAL_BUTTON:
        "Intervalle de temps général pour les boutons de production",
      VERIFY_COMPONENTS: "Vérifiez les composants",
      VERIFY_COMPONENTS_ERROR: "Vous devez vérifier les composants avant",
      DB_PRINT_CONTAINER_TEMPLATE: environment.eurogerm
        ? "Commandes à envoyer lorsque le cycle est fermé"
        : "Commandes à envoyer lorsque le conteneur est fermé",
      CLIENT_NOT_CONFIGURED: "Vous devez configurer le client",
      THE_SPECIFIED_CONTAINER_DOES_NOT_EXIST: environment.eurogerm
        ? "Le cycle spécifié n'existe pas"
        : "Le conteneur spécifié n'existe pas",
      NEXT_CONTAINER_CODE: environment.eurogerm
        ? "Code pour le cycle suivant"
        : "Code pour le conteneur suivant",
      EMPTY_NEXT_CONTAINER_CODE: environment.eurogerm
        ? "Le code dans le cycle suivant ne peut pas être vide, si vous souhaitez terminer la production, faites-le directement"
        : "Le code dans le conteneur suivant ne peut pas être vide, si vous souhaitez terminer la production, faites-le directement",
      CONTAINERS: environment.eurogerm ? "Cycles" : "Conteneurs",
      ACTIVE_CONTAINERS: environment.eurogerm
        ? "Cycles actifs"
        : "Conteneurs actifs",
      PENDING_CONTAINERS: environment.eurogerm
        ? "Cycles en attente"
        : "Conteneurs en attente",
      NO_ACTIVE_CONTAINERS: environment.eurogerm
        ? "Aucun cycle actif"
        : "Aucun conteneur actif",
      NO_PENDING_CONTAINERS: environment.eurogerm
        ? "Aucun cycle en attente"
        : "Aucun conteneur en attente",
      NETWORK_SETTINGS: "Paramètres réseau",
      EDIT_NETWORK_SETTINGS: "Modifier la configuration du réseau",
      PASSWORD: "Mot de passe",
      ADAPTER: "Adaptateur",
      ROUND_TOTAL_COUNT_TO_NEAREST_HALF: "Compte rond",
      SELECT_CONTAINER: "Sélectionner un conteneur",
      CONTAINERS_EMPTY: "Pas de conteneurs",
      CLOSED_CONTAINERS: "Conteneurs fermés",
      CHANGE_OF: "Changer OF",
      SHOW_CHANGE_OF_BUTTON: 'Afficher le bouton "Changer OF"',
      TOOLING: "Outillage",
      AUTO_START_PRODUCTION_MODE: "Mode de démarrage de production automatique",
      MINIMUM_CADENCE: "Cadence minimale",
      MINIMUM_TIME: "Temps minimum",
      CHANGE_REFERENCE: "Changer la référence",
      TOTAL_OF: "Quantité totale OF",
      PRODUCED: "Produit",
      MUST_START_MASTER_PRODUCTION_BEFORE:
        'Vous devez démarrer la production sur la machine "Maître"',
      MASTER_IN_USE:
        'La machine "Master" est utilisée par un autre travailleur, vérifiez si les productions précédentes ont été fermées',
      MUST_CLOSE_PRODUCTION_FROM_MASTER:
        'Vous devez fermer la production de la machine "Maître"',
      GENERAL: "General",
      CLOUD: "Nuage",
      BUTTONS: "Boutons",
      COMMANDS: "Commandes",
      SHOW_JUSTIFY_NOK_BUTTON: 'Afficher le bouton "Justifier NOK"',
      PRODUCTION_BUTTONS_VISIBLE: "Boutons de production visibles",
      LOTS: "Lots",
      LOCATION: "Ubication",
      DISABLE_ABILITY_TO_CHANGE_OK_NOK:
        "Désactiver la modification des quantités OK/NOK à la fin de la production",
      ROUND_COUNT_TO_NEAREST_HALF: "Arrondir le compte total au demi",
      SELECT_A_COMPONENT: "Sélectionner un composant",
      MAN: "Manual",
      MP: "Matière première",
      TP: "Type d'arrêt",
      NO_IMAGE_ATTACHED: "Aucune image jointe",
      IMAGE_ATTACHED: "Image jointe",
      CAPTURE_CAMERA: "Capturer caméra",
      CAPTURE_IMAGE: "Capturer l'image",
      SELECT_CAMERA: "Sélectionner la caméra",
      DEVICES: "Appareils",
      CAPTURE_SNAPSHOT: "Capturer un instantané",
      ADD_IMAGE: "Ajouter une image",
      AVAILABLE: "Disponible",
      IN_USE: "Utilisé",
      MACHINE_ALREADY_IN_USE: "La machine est déjà utilisée par l'utilisateur {0}",
      OPEN_KEYBOARD: "Ouvrir le clavier"
    },
    FOOTER: {},
  },
};
